export interface UDTResult {
	_id?: string;
	week: number;
	visitNumber: number;
	visitDate: Date;
	result: string;
	notes: string;
	excusedAbsenceNotes?: string;
	providerId: string;
	amountEarned?: number;
}

export interface UDTResultCashOut extends UDTResult {
	isbankIncentive: boolean;
	productId: string;
	productName: string;
	delivery: string;
	deliveryValue?: string;
	udtResultId?: string;
	incentiveType?: "GC" | "PPC";
}

export enum EnrollmentStatus {
	ACTIVE = "ACTIVE",
	COMPLETED = "COMPLETED",
	DISENROLLED = "DISENROLLED",
	PAUSED = "PAUSED",
}

export interface UDTResultEdit {
	week: number;
	visitNumber: number;
	providerId: string;
	result: string;
	notes: string;
	isbankIncentive: boolean;
	delivery: string;
	productId: string;
	productName: string;
	udtId: string;
	incentiveType?: "GC" | "PPC";
}

export interface BankRedeemRequest {
	providerId: string;
	delivery: string;
	productId: string;
}

export interface ConfirmExcusedAbsenceRequest {
	excusedAbsenceNotes: string;
	changeToUnexcused: boolean;
}

export interface ConfirmExcusedAbsenceResponse {
	enrollmentId: string;
	udtResult: {
		udtResultId: string;
		visitDate: string;
		visitNumber: number;
		weekNumber: number;
		notes: string;
		excusedAbsenceNotes: string;
	};
}
